// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"fb45350da24b67d18a04","691":"14a89b1d688ed16767c4"}[chunkId] + ".js";
};